import { MQueryAssetScore } from "~/components/DataQueries/DataQuery";
import { AssetOrderField } from "~/operations";
import { ComplianceTable } from "~/components/Completion/ComplianceTable";
import { Space } from "~/lib/types";
import { PaginationProps, PaginationRange } from "../pagination";
import { DataQueryRow } from "~/components/DataQueries/DataQueryRow";
import { Header } from "~/types/table";
import { Box, Skeleton, TableCell, TableRow } from "@mui/material";
import { useMemo } from "react";

type DataQueryListViewProps = {
  tableHeaders: Header[];
  assets: MQueryAssetScore[];
  pageItems: PaginationRange;
  space: Space;
  queryMrn: string;
  paginationProps?: PaginationProps;
};

export function DataQueryListView({
  tableHeaders,
  assets,
  pageItems,
  space,
  queryMrn,
  paginationProps,
}: DataQueryListViewProps) {
  const listedAssets = useMemo(() => {
    return assets.slice(pageItems.from, pageItems.to);
  }, [assets, pageItems]);

  return (
    <ComplianceTable
      tableHeaders={tableHeaders}
      defaultActiveColumn={AssetOrderField.Name}
      paginationProps={paginationProps}
    >
      {listedAssets.length === 0 ? (
        <DataQuerySkeleton />
      ) : (
        listedAssets.map((asset, i) => {
          const assetId = asset.assetMrn?.split("/").pop();
          const to = `/space/inventory/${assetId}/data-queries?spaceId=${space.id}&queryMrn=${queryMrn}`;
          return (
            <DataQueryRow
              key={`${asset?.assetMrn}-${i}`}
              asset={asset}
              queryMrn={queryMrn}
              index={i}
              to={to}
            />
          );
        })
      )}
    </ComplianceTable>
  );
}

export function DataQuerySkeleton() {
  return (
    <>
      {Array.from({ length: 10 }).map((_, i) => (
        <TableRow key={i}>
          <TableCell sx={{ height: 67 }}>
            <Skeleton variant="text" width="60%" />
          </TableCell>
          <TableCell>
            <Skeleton variant="text" width={100} />
          </TableCell>
          <TableCell align="right" width={75}>
            <Box display="flex" alignItems="center" justifyContent="flex-end">
              <Skeleton variant="circular" height={24} width={24} />
            </Box>
          </TableCell>
        </TableRow>
      ))}
    </>
  );
}
